import { render, staticRenderFns } from "./EditDepartmentModal.vue?vue&type=template&id=fbe05b98&"
import script from "./EditDepartmentModal.vue?vue&type=script&lang=js&"
export * from "./EditDepartmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbe05b98')) {
      api.createRecord('fbe05b98', component.options)
    } else {
      api.reload('fbe05b98', component.options)
    }
    module.hot.accept("./EditDepartmentModal.vue?vue&type=template&id=fbe05b98&", function () {
      api.rerender('fbe05b98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/EditDepartmentModal.vue"
export default component.exports